import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=358ed10c&lang=scss&module=true"
cssModules["$style"] = style0
import "./Footer.vue?vue&type=style&index=1&id=358ed10c&lang=scss&scoped=true"
import "./Footer.vue?vue&type=style&index=2&id=358ed10c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-358ed10c"]])

export default __exports__